import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CANDIDATE_DETAILS_ROUTES } from './candidate-details.routes';

@NgModule({
  imports: [RouterModule.forChild(CANDIDATE_DETAILS_ROUTES)],
  exports: [RouterModule],
})
export class CandidateDetailsRoutingModule {}
